import { AxiosResponse } from 'axios';
import telemetryService from '|/app/services/telemetry/telemetry-service';
import axiosInstance from '|/helpers/axios';
import { Summary } from './purchaseApi.types';
import getElapsedTimeInSeconds from '../utils/getElapsedTimeInSeconds';

const baseUrl = `${process.env.PURCHASE_API_URL}/api`;

export const declineVinEtching = (abortSignal?: AbortSignal) => {
  const startTime = performance.now();

  telemetryService.trackEvent({
    name: 'purchase-api:declineVinEtching:start'
  });

  return axiosInstance
    .post<never, AxiosResponse<void>>(
      `${baseUrl}/v1/vinetching/decline`,
      {},
      { signal: abortSignal }
    )
    .then(res => {
      const elapsedTimeInSeconds = getElapsedTimeInSeconds(startTime);

      telemetryService.trackEvent({
        name: 'purchase-api:declineVinEtching:success',
        context: {
          elapsedTimeInSeconds: elapsedTimeInSeconds
        }
      });

      return res.data;
    })
    .catch((err: unknown) => {
      const elapsedTimeInSeconds = getElapsedTimeInSeconds(startTime);

      telemetryService.trackError({
        error: err,
        name: 'purchase-api:declineVinEtching:error',
        context: {
          elapsedTimeInSeconds: elapsedTimeInSeconds
        }
      });

      return Promise.reject(
        err instanceof Error ? err : new Error('Failed to decline vin etching.')
      );
    });
};

export const fetchOrderSummary = (abortSignal?: AbortSignal): Promise<Summary> => {
  const startTime = performance.now();

  telemetryService.trackEvent({
    name: 'purchase-api:fetchOrderSummary:start'
  });

  return axiosInstance
    .get<Summary, AxiosResponse<Summary>>(`${baseUrl}/v1/summary`, {
      signal: abortSignal
    })
    .then(res => {
      const elapsedTimeInSeconds = getElapsedTimeInSeconds(startTime);

      telemetryService.trackEvent({
        name: 'purchase-api:fetchOrderSummary:success',
        context: {
          elapsedTimeInSeconds: elapsedTimeInSeconds
        }
      });

      return res.data;
    })
    .catch((err: unknown) => {
      const elapsedTimeInSeconds = getElapsedTimeInSeconds(startTime);

      telemetryService.trackError({
        error: err,
        name: 'purchase-api:fetchOrderSummary:error',
        context: {
          elapsedTimeInSeconds: elapsedTimeInSeconds
        }
      });

      return Promise.reject(
        err instanceof Error ? err : new Error('Failed to fetch order summary.')
      );
    });
};
